module.exports = __webpack_public_path__ + "static/img/miyu2.70e0710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/miyu2.png
// module id = JhoI
// module chunks = 24